import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess} from "@insite/client-framework/HandlerCreator";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { GetCustomerWarehouse, GetCustomerWarehouseParameter } from "@thos/Store/Data/CustomerWarehouse/Services/CustomerWarehouseService";

type Parameter = GetCustomerWarehouseParameter & HasOnSuccess<WarehouseModel> & HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<Parameter,
    GetCustomerWarehouseParameter,
    WarehouseModel
>;

export const GetCustomerWarehouseFromApi: HandlerType = async props => {
    const { parameter } = props;

    const apiParameter: GetCustomerWarehouseParameter = {
        billTo: parameter.billTo,
        shipTo: parameter.shipTo
    }

    const result = await GetCustomerWarehouse(apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [GetCustomerWarehouseFromApi, ExecuteOnSuccessCallback];
const getCustomerWarehouse = createHandlerChainRunner(chain, "getCustomerWarehouse");
export default getCustomerWarehouse;